<div class="modal-overlay" (click)="closeModalOnClickOutside($event)">
  <div class="modal-change-photo">
    <div class="modal-header">
      <h2 class="modal-title">AŽURIRANJE PODATAKA - {{ membershipCard.firstName }} {{ membershipCard.lastName }}</h2>
      <button class="close-button" (click)=" this.closeModalChangePhoto.emit()">x</button>
    </div>

    <div class="modal-body">
      <p class="dark-text" *ngIf="gdprQuestions.length > 0">Dajem pristanak na obradu i daljnje korištenje osobnih podatak u svrhu:</p>
      <form *ngIf="gdprQuestionsForm" [formGroup]="gdprQuestionsForm" (ngSubmit)="onSubmit()">
        <div *ngFor="let question of gdprQuestions">
          <div class="form-group">
            <input type="checkbox" id="gdprQuestion{{question.id}}" formControlName="gdprQuestion{{question.id}}" name="gdprQuestion{{question.id}}" value="{{question.id}}" (change)="clearErrorMessage()">
            <label for="gdprQuestion{{question.id}}">{{question.text}}</label>
          </div>
        </div>

        <div>
          <input id="image-upload" type="file" (change)="fileChangeEvent($event)" />
          <div class="load-photo-container">
            <image-cropper
              class="image-cropper"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="3 / 3"
              format="png"
              (imageCropped)="imageCropped($event)"
              *ngIf="imageChangedEvent"
              [resizeToWidth]="500"
              [resizeToHeight]="500"
            ></image-cropper>

            <div class="buttons-container-upload-image">
              <label for="image-upload" class="button yellow-button w-auto">Učitajte fotografiju</label>
              <button class="button cancel-button" (click)="removeImage()" *ngIf="croppedImage">Ukloni fotografiju</button>
            </div>
            <p><span class="fw-500">Napomena:</span> Potrebno je učitati fotografiju jasno vidljivog lica. Važno je da fotografija bude kvalitetna i da jasno prikazuje vaše lice bez prepreka ili zamućenja.</p>
          </div>
        </div>

        <p class="error-message">{{ errorMessage }}</p>

        <div class="flex flex-end">
          <button class="button yellow-button w-auto">Spremi promjene</button>
        </div>
      </form>
    </div>    
  </div>
</div>